import { createSelector } from 'reselect';
import get from 'lodash/fp/get';
import {
  languageCodeTagTaxonomyMap,
  languageCodeCategoryTaxonomyMap,
} from 'config/types/language';
import { CATEGORY_ARCHIVE } from 'config/types/path';
import getPathMap from './getPathMap';
import getMatch from './getMatch';
import { getEdition } from './getEdition';

export const getTaxonomy = ({ pathType }, currentEdition) => {
  if (pathType === CATEGORY_ARCHIVE) {
    return languageCodeCategoryTaxonomyMap[currentEdition];
  }
  return languageCodeTagTaxonomyMap[currentEdition];
};

const getTerm = createSelector(
  [getPathMap, getMatch, get('term'), getEdition],
  (pathMap, match, terms, currentEdition) => {
    const { slug } = match.params;
    const taxonomy = getTaxonomy(match, currentEdition);
    const id = get(`${taxonomy}.idBySlug.${slug}`, terms);
    const term = get(`${taxonomy}.byId.${id}`, terms);
    return term ? {
      ...term,
    } : false;
  },
);

export default getTerm;
